import * as ActionTypes from './index';

export function changeReferralSettingsState(payload) {
	return {
		type: ActionTypes.CHANGE_REFERRAL_SETTINGS_STATE,
		payload
	}
}

export function getCaseReferralKeywords(payload) {
    return {
        type: ActionTypes.GET_CASE_REFERRAL_KEYWORDS,
        payload: payload
    }
}

export function getCaseReferralKeywordsSuccess(payload) {
    return {
        type: ActionTypes.GET_CASE_REFERRAL_KEYWORDS_SUCCESS,
        payload: payload
    }
}

export function getCaseReferralKeywordsFail(payload) {
    return {
        type: ActionTypes.GET_CASE_REFERRAL_KEYWORDS_FAIL,
        payload: payload
    }
}

export function createCaseReferralKeywordAndAddAnother(payload) {
    return {
        type: ActionTypes.CREATE_CASE_REFERRAL_KEYWORD_AND_ADD_ANOTHER,
        payload: payload
    }
}

export function createCaseReferralKeyword(payload) {
    return {
        type: ActionTypes.CREATE_CASE_REFERRAL_KEYWORD,
        payload: payload
    }
}

export function createCaseReferralKeywordSuccess(payload) {
    return {
        type: ActionTypes.CREATE_CASE_REFERRAL_KEYWORD_SUCCESS,
        payload: payload
    }
}

export function createCaseReferralKeywordFail(payload) {
    return {
        type: ActionTypes.CREATE_CASE_REFERRAL_KEYWORD_FAIL,
        payload: payload
    }
}


export function changeKeywordAdditionFormReferrer(payload) {
    return {
        type: ActionTypes.CHANGE_KEYWORD_ADDITION_FORM_REFFERER,
        payload: payload
    }
}

export function changeKeywordAdditionForm(payload) {
    return {
        type: ActionTypes.CHANGE_KEYWORD_ADDITION_FORM,
        payload: payload
    }
}

export function openCaseReferralKeywordAdditionModal(payload) {
    return {
        type: ActionTypes.OPEN_CASE_REFERRAL_KEYWORD_ADDITION_MODAL,
        payload: payload
    }
}

export function closeCaseReferralKeywordAdditionModal(payload) {
    return {
        type: ActionTypes.CLOSE_CASE_REFERRAL_KEYWORD_ADDITION_MODAL,
        payload: payload
    }
}

//action that requests filtered policy
export function requestFilteredPolicy(caseTypeId, subCaseTypeId, solicitorGroupId) {
	return {
		type: ActionTypes.REQUEST_FILTERED_POLICY,
		payload: {
			caseTypeId,
			subCaseTypeId,
			solicitorGroupId
		}
	}
}

//action that requests filtered policy
export function requestApplicationFormTemplate() {
	return {
		type: ActionTypes.REQUEST_APPLICATION_FORM_TEMPLATE
	}
}

//action that receives filtered policy
export function receiveFilteredPolicy(policy) {
	return {
		type: ActionTypes.RECEIVE_FILTERED_POLICY,
		payload: policy
	}
}
//action that receives filtered policy
export function receiveApplicationFormTemplate(template) {
	return {
		type: ActionTypes.RECEIVE_APPLICATION_FORM_TEMPLATE,
		payload: template
	}
}

//action that receives failed request get filtered policy
export function failedToReceiveFilteredPolicy(response) {
	return {
		type: ActionTypes.FAILED_TO_RECEIVE_FILTERED_POLICY,
		payload: response
	}
}

export function requestGetPolicies() {
	return {
		type: ActionTypes.REQUEST_GET_POLICIES
	}
}

//action that receives response from GET policies
export function receiveGetPolicies(policies) {
	return {
		type: ActionTypes.RECEIVE_GET_POLICIES,
		payload: policies
	}
}

//action that receives failed response from getting policies
export function failedToGetPolicies(response) {
	return {
		type: ActionTypes.FAILED_TO_GET_POLICIES,
		payload: response
	}
}

//action that requests GET questions
export function requestGetQuestions() {
	return {
		type: ActionTypes.REQUEST_GET_QUESTIONS
	}
}

//action that receives GET questions
export function receiveGetQuestions(questions) {
	return {
		type: ActionTypes.RECEIVE_GET_QUESTIONS,
		payload: questions
	}
}

//action that receives bad request GET questions
export function receiveBadRequestGetQuestions(response) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_GET_QUESTIONS,
		payload: response
	}
}

//action that receives GET case types
export function receiveGetCaseTypes(caseTypes) {
	return {
		type: ActionTypes.RECEIVE_GET_CASE_TYPES,
		payload: caseTypes
	}
}

//action that changes redux store selected field
export function changeField(field, value) {
	return {
		type: ActionTypes.CHANGE_FIELD,
		payload: {
			key: field,
			value: value
		}
	}
}

//action that received the sub case types
export function receiveSubCaseTypes(subCaseTypes) {
	return {
		type: ActionTypes.RECEIVE_SUB_CASE_TYPES,
		payload: subCaseTypes
	}
}

//action that received the sub case types
export function requestGetSubCaseTypes(caseTypeId) {
	return {
		type: ActionTypes.REQUEST_GET_SUB_CASE_TYPE,
		payload: caseTypeId
	}
}

//action that stores to the redux the checked question
export function changeSelectedQuestions(item) {
	return {
		type: ActionTypes.CHANGE_SELECTED_QUESTIONS,
		payload: item
	}
}

//action that requests post new policy
export function requestPostPolicy(sendBody) {
	return {
		type: ActionTypes.REQUEST_POST_POLICY,
		payload: sendBody
	}
}

//action that receives post new policy response
export function receiveBadRequestPostPolicyResponse(response) {
	let msg = '';
	if(response.includes('There is already a policy') || response.includes('has an invalid trigger')){
		msg = response
	}
	else (
		msg = 'Error posting new form. Please try again later.'
	)
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_POST_POLICY_RESPONSE,
		payload: msg
	}
}

export function receivePostPolicyResponse(response) {

	return {
		type: ActionTypes.RECEIVE_POST_POLICY_RESPONSE,
		payload: response
	}
}


//action that change question trigger
export function changeQuestionTrigger(questionId, trigger, triggerValue, question ) {
	return {
		type: ActionTypes.CHANGE_QUESTION_TRIGGER,
		payload: {
			key: questionId,
			triggerKey: trigger,
			value: triggerValue,
			question: question
		}
	}
}

//action that changes referral trigger
export function changeReferralTrigger(conditionType,referTo,isEnabled ) {
	return {
		type: ActionTypes.CHANGE_REFERRAL_TRIGGER,
		payload: {
			refTriggerSetting: {conditionType:conditionType,referTo:referTo}
		}
	}
}

//action that changes the info state array (which info dialog boxes should render)
export function changeRefSettingsInfoState(id) {
	return {
		type: ActionTypes.CHANGE_REF_SETTINGS_INFO_STATE,
		payload: id
	}
}

//action that requests patch policy questions group
export function requestPatchPolicyQuestionsGroup(weight, groupId){
	return {
		type: ActionTypes.REQUEST_PATCH_POLICY_QUESTIONS_GROUP,
		payload: {
			weight,
			groupId
		}
	}
}

//action that receives patch policy questions group response
export function receivePatchPolicyQuestionsGroup(response){
	return {
		type: ActionTypes.RECEIVE_PATCH_POLICY_QUESTIONS_GROUP,
		payload: response
	}
}

//action that receives bad request patch policy questions group
export function failedToPatchPolicyQuestionsGroup(response) {
	return {
		type: ActionTypes.FAILED_TO_PATCH_POLICY_QUESTIONS_GROUP,
		payload: response
	}
}